var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Fragment } from 'react';
import * as R from 'ramda';
import * as X from '@unitarius/xbpm-runtime';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { prefixValue } from '../../common/utils/_.utils';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FormulaChangeProperty } from '@unitarius/xbpm-runtime';
import { findElementBy } from '@unitarius/xbpm-runtime/lib/services/utils/def.utils';
var getClass = function (frontOptions) {
    var className = frontOptions.className, isPrintable = frontOptions.isPrintable;
    return ("" + mapElementClass(frontOptions) + (isPrintable === false ? ' HideForPrint' : '') + prefixValue(className, ' ')).trim();
};
var mapTableRowValues = R.pipe(R.map(function (_a) {
    var code = _a.code, value = _a.value;
    return [code, value];
}), R.fromPairs);
var mapTableValue = R.map(function (row) { return (__assign(__assign({}, mapTableRowValues(row.value || [])), { __id: row.id })); });
var header2columns = R.map(function (it) { return R.zipObj(['field', 'header'], [R.prop('code', it), R.prop('value', it)]); });
var pickContainerState = R.pick(['editModal', 'expandedRows', 'selectedRow']);
;
var TableContainer = /** @class */ (function (_super) {
    __extends(TableContainer, _super);
    function TableContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.renderColumnTemplate = function (rowData, column) {
            var block = _this.findRowDetailsBlock(rowData.__id);
            if (block) {
                var template = X.FormUtils.def.findElementBy('code', column.templateBlockCode, block);
                if (template) {
                    return React.createElement("div", null, _this.renderChild(template));
                }
            }
            return (null);
        };
        _this.renderRowDetailsTemplate = function (rowData) {
            if (_this.tableMode !== 'viewDetail') {
                return (null);
            }
            var block = _this.mapRowDetailsBlock(_this.findRowDetailsBlock(rowData.__id));
            if (!block) {
                console.error('Блок с ID = ' + (rowData.id || 'new') + ' не найден!');
                return (undefined);
            }
            return React.createElement("div", null, _this.renderChild(_this.mapRowDetailsBlock(block), _this.hideRowDetailsTemplateBlock));
        };
        _this.hideRowDetailsTemplateBlock = R.when(function (it) { return !!_this.tableColumns.find(function (col) { return col.templateBlockCode && it.code === col.templateBlockCode; }); }, function (it) { return (__assign(__assign({}, it), { parentId: 'template', hidden: true })); });
        //
        _this.mapRowDetailsBlock = X.FormUtils._.mapElementTreeAsImmutable(_this.hideRowDetailsTemplateBlock);
        // find table row details block
        _this.findRowDetailsBlock = function (__id) {
            return R.pipe(_this.form.getElementDefinition.bind(_this.form), R.path(['elements', 0]))(__id);
        };
        _this.onSort = function (params) {
            var paginatorId = _this.state.paginatorId;
            if (!paginatorId) {
                _this.setState(params, _this.forceUpdate);
                if (_this.tableParamsEnabled) {
                    _this.setTableParams(params);
                }
            }
            else {
                // for server sort
                var sortField = params.sortField, sortOrder = params.sortOrder;
                var paginator = _this.form.getElementDefinition(paginatorId);
                var nextValue = __assign(__assign({}, paginator.value || {}), { sortField: sortField, sortOrder: sortOrder === -1 ? 'desc' : 'asc' });
                _this.form.handlePropertyChange(paginatorId, FormulaChangeProperty.VALUE, nextValue, false);
                var type = paginator.actionButton;
                if (type) {
                    _this.props.onEvent({ type: type, target: paginator });
                }
            }
        };
        _this.onColumnResizeEnd = function () {
            if (_this.tableParamsEnabled) {
                setTimeout(function () {
                    var ths = Array.from(_this.tableRef.table.getElementsByTagName('th'));
                    var columnsWidth = _this.state.def.frontOptions.columns.map(function (column, i) { return ({
                        label: column.field,
                        width: ths[i].offsetWidth
                    }); });
                    _this.setTableParams({ columnsWidth: columnsWidth });
                }, 500);
            }
        };
        // table handlers
        _this.handleRowToggle = function (_a) {
            var expandedRows = _a.data;
            return _this.setState({ expandedRows: expandedRows });
        };
        _this.handleSelect = function (event) {
            var originalEvent = event.originalEvent, data = event.data;
            if (originalEvent.defaultPrevented) {
                return;
            }
            _this.setState({ selectedRow: data.__id }, function () {
                if (_this.tableMode === 'clickAction') {
                    _this.handleClick(event);
                }
            });
        };
        _this.handleDoubleClick = function (event) {
            var originalEvent = event.originalEvent;
            originalEvent.preventDefault();
            originalEvent.stopPropagation();
            _this.handleClick(event);
        };
        _this.handleClick = function (_a) {
            var data = _a.data;
            var _b = _this.tableDef, type = _b.actionButton, elements = _b.elements;
            if (type && elements) {
                var target = elements.find(R.propEq('id', data.__id));
                _this.props.onEvent({ type: type, target: target });
            }
        };
        _this.copyToClipboard = function () {
            var item = _this.tableRef.table;
            if (item) {
                if (window.getSelection) {
                    var range = document.createRange();
                    range.selectNode(item);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                    document.execCommand('copy');
                    _this.setState({ isCopied: true }, _this.forceUpdate);
                }
            }
        };
        var paginator = _this.getPaginator();
        _this.state = __assign(__assign(__assign(__assign(__assign({}, _this.state), { expandedRows: [] }), _this.tableParamsEnabled ? _this.getTableParams() : {}), _this.getPaginatorSortParams(paginator && paginator.id)), { paginatorId: paginator && paginator.id, isCopied: false });
        return _this;
    }
    TableContainer.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var table = this.props.initialDef.frontOptions['scrollable'] ? 'container' : 'table';
        Array
            .from(this.tableRef[table].getElementsByTagName('td'))
            .forEach(function (td) { return td.style.width = ''; });
    };
    ;
    Object.defineProperty(TableContainer.prototype, "tableDef", {
        get: function () {
            return this.state.def;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableMode", {
        get: function () {
            return R.path(['frontOptions', 'mode'], this.tableDef) || 'view';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableType", {
        get: function () {
            return R.path(['frontOptions', 'type'], this.tableDef) || 'expanded';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableColumns", {
        get: function () {
            var defColumns = this.tableDef.columns || [];
            return !!defColumns.length
                ? header2columns(defColumns)
                : R.path(['frontOptions', 'columns'], this.tableDef) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableRows", {
        get: function () {
            return this.tableDef.elements || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableValue", {
        get: function () {
            return mapTableValue(this.tableRows);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "expandedRows", {
        get: function () {
            return this.tableType === 'simple' || !this.state.expandedRows || !this.tableValue ? [] : this.state.expandedRows;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "selectedRow", {
        get: function () {
            return this.tableType === 'simple' ? this.state.selectedRow : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "isLocalPaginatorEnabled", {
        get: function () {
            var _a = this.state, paginatorId = _a.paginatorId, def = _a.def;
            var rows = def.frontOptions.rows;
            return !paginatorId && rows > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "sortField", {
        get: function () {
            var sortField = this.state.def.frontOptions.sortField;
            return this.state.sortField || sortField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "sortOrder", {
        get: function () {
            var sortOrder = this.state.def.frontOptions.sortOrder;
            return this.state.sortOrder || +sortOrder;
        },
        enumerable: false,
        configurable: true
    });
    TableContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !R.eqBy(pickContainerState, this.state, nextState) || _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
    };
    TableContainer.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, hidden = def.hidden, id = def.id;
        if (hidden) {
            return (null);
        }
        var style = frontOptions.style, hint = frontOptions.hint, scrollHeight = frontOptions.scrollHeight, scrollHeightMeasure = frontOptions.scrollHeightMeasure, header = frontOptions.header, sortField = frontOptions.sortField, sortOrder = frontOptions.sortOrder, showClipboardBtn = frontOptions.showClipboardBtn, restOptions = __rest(frontOptions, ["style", "hint", "scrollHeight", "scrollHeightMeasure", "header", "sortField", "sortOrder", "showClipboardBtn"]);
        var value = this.tableValue;
        var selection = this.selectedRow && value.find(R.propEq('__id', this.selectedRow));
        var onRowSelect = this.tableType === 'simple' ? this.handleSelect : undefined;
        var onRowDoubleClick = this.tableMode === 'doubleClickAction' ? this.handleDoubleClick : undefined;
        return React.createElement("div", { className: getClass(restOptions) },
            React.createElement("div", { style: { marginBottom: "8px", display: !showClipboardBtn ? "none" : "flex", justifyContent: "flex-end" } },
                React.createElement(Button, { type: 'button', onClick: this.copyToClipboard, icon: !this.state.isCopied ? "fas fa-clipboard" : "fas fa-clipboard-check", className: "p-button-rounded p-button-text", tooltip: '\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430' })),
            React.createElement(DataTable, __assign({ ref: function (ref) { return _this.tableRef = ref; }, header: this.renderHeader(def.header || header), key: id, id: id, dataKey: '__id', responsive: true, autoLayout: true, style: __assign(__assign({}, style || {}), { visibility: hidden ? 'hidden' : 'inherit' }), expandedRows: this.expandedRows, value: value, onRowToggle: this.handleRowToggle, onRowSelect: onRowSelect, onRowDoubleClick: onRowDoubleClick, selectionMode: this.tableType === 'simple' ? 'single' : '', selection: selection, rowExpansionTemplate: this.renderRowDetailsTemplate, globalFilter: this.state.globalFilter, scrollHeight: !!scrollHeight && !!scrollHeightMeasure ? (scrollHeight + scrollHeightMeasure) : '256px', onSort: this.onSort, sortField: this.sortField, sortOrder: this.sortOrder, onColumnResizeEnd: this.onColumnResizeEnd, paginator: this.isLocalPaginatorEnabled }, omitSpecialProperties(restOptions)), this.renderColumns()));
    };
    TableContainer.prototype.renderColumns = function () {
        var _this = this;
        return __spreadArrays(this.tableType === 'expanded' ? [React.createElement(Column, { key: 'expander', expander: true, style: { width: '.1%' } })] : [], this.tableColumns.map(function (it, i) {
            var width = it.width && it.widthMeasure ? (it.width + it.widthMeasure) : '';
            var columnsWidth = _this.getTableParams().columnsWidth;
            if (_this.tableParamsEnabled && columnsWidth && columnsWidth[i]) {
                width = columnsWidth[i].width;
            }
            var style = { textAlign: it.align || '', width: width };
            return React.createElement(Column, __assign({ key: it.field, body: !!it.templateBlockCode ? _this.renderColumnTemplate : null, style: style, excludeGlobalFilter: !it.filter, filterMatchMode: "contains", filterPlaceholder: "\u041F\u043E\u0438\u0441\u043A..." }, R.omit(['align', 'width', 'type', 'widthMeasure'], it)));
        }));
    };
    TableContainer.prototype.renderHeader = function (header) {
        var _this = this;
        if (header === void 0) { header = ''; }
        var hasFilter = !!this.tableColumns.filter(function (it) { return it.filter; }).length;
        if (hasFilter) {
            return React.createElement(Fragment, null,
                header,
                React.createElement("div", { className: 'p-hidden p-medium-visible' },
                    React.createElement(InputText, { type: "search", onInput: function (e) {
                            _this.setState({ globalFilter: R.clone(e).target.value });
                            _this.forceUpdate();
                        }, placeholder: "\u041F\u043E\u0438\u0441\u043A..." })));
        }
        return header;
    };
    Object.defineProperty(TableContainer.prototype, "tableParamsEnabled", {
        // table params
        get: function () {
            var frontOptions = this.state.def.frontOptions;
            return !!frontOptions['saveColumnParams'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableContainer.prototype, "tableParamsKey", {
        get: function () {
            return "xbpm:table." + this.state.def.code;
        },
        enumerable: false,
        configurable: true
    });
    TableContainer.prototype.getTableParams = function () {
        try {
            var params = localStorage.getItem(this.tableParamsKey);
            if (params) {
                return JSON.parse(params);
            }
        }
        catch (_a) {
            // broken params
        }
        return { sortField: null, sortOrder: null };
    };
    TableContainer.prototype.setTableParams = function (val) {
        if (!!val) {
            localStorage.setItem(this.tableParamsKey, JSON.stringify(__assign(__assign({}, this.getTableParams()), val)));
        }
        else {
            localStorage.removeItem(this.tableParamsKey);
        }
    };
    //
    TableContainer.prototype.getPaginator = function () {
        var paginatorCode = this.state.def.frontOptions.paginatorCode;
        return findElementBy('code', paginatorCode, this.form.formDefinition);
    };
    TableContainer.prototype.getPaginatorSortParams = function (paginatorId) {
        if (paginatorId) {
            var paginator = this.form.getElementDefinition(paginatorId);
            if (paginator.value) {
                var _a = (paginator.value || {}), sortField = _a.sortField, sortOrder = _a.sortOrder;
                return {
                    sortField: sortField,
                    sortOrder: sortField ? (sortOrder === 'desc' ? -1 : 1) : null
                };
            }
        }
        return {};
    };
    return TableContainer;
}(X.FormBaseElement));
export { TableContainer };
//# sourceMappingURL=Table.js.map